import {Directive, HostListener, inject, input, InputSignal} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[appMaxlength]',
})
export class MaxlengthDirective {
    private readonly ngControl: NgControl = inject(NgControl);

    maxlength: InputSignal<string> = input<string>('', {alias: 'appMaxlength'});
    min: InputSignal<string> = input<string>('');
    max: InputSignal<string> = input<string>('');

    @HostListener('ngModelChange', ['$event'])
    onModelChange(newValue: any): void {
        const maxLength = Number(this.maxlength());
        const min = Number(this.min());
        const max = Number(this.max() ? this.max() : Math.pow(10, maxLength) - 1);
        if ((newValue ?? '').toString().length > maxLength || typeof newValue !== 'number') {
            newValue = newValue?.toString().slice(0, maxLength);
        }
        if (newValue < min) newValue = min;
        if (newValue > max) newValue = max;
        if (newValue !== this.ngControl.control!.value) {
            this.ngControl.valueAccessor!.writeValue(newValue);
            this.ngControl.control!.setValue(newValue, {emitEvent: false});
        }
    }
}
